import React, {useState} from "react";
import {Form} from "react-bootstrap";
import {router} from "@inertiajs/react";
import axios from "axios";
import {FlexToast, useExternalControls} from "laravel-inertia-backend";

/**
 * Checkbox-Zelle für "Rückmeldung erhalten" in der Kampagnen-Empfänger-
 * Übersicht. Speichert direkt beim Umschalten über die Feedback-Route und
 * lädt danach die Tabelle neu (analog dem retry()-Muster in TransmissionJobs).
 */
export default function FeedbackCheckboxTableCell({id, className, childSwitch, rowData}) {
    const {addToast} = useExternalControls();
    const [saving, setSaving] = useState(false);

    const toggle = async (e) => {
        const checked = e.target.checked;
        setSaving(true);
        try {
            await axios.patch(`/campaigns/recipients/${rowData.id}/feedback`, {feedback_received: checked});
            router.reload({only: ["recipients"]});
        } catch (err) {
            const message = err.response?.data?.message || err.message || "Speichern fehlgeschlagen";
            addToast(<FlexToast variant="danger" title="Kampagnen-Empfänger" autohide={false} message={message}/>);
        } finally {
            setSaving(false);
        }
    };

    return (
        <td key={id} className={`border px-4 py-2 text-center${className ? " " + className : ""}`}>
            {childSwitch}
            <Form.Check
                type="checkbox"
                checked={!!rowData.feedback_received}
                disabled={saving}
                onChange={toggle}
            />
        </td>
    );
}
